import '../styles/index.scss';
import '../App.css';
import DashboardPage from './DashboardPage/DashboardPage';

export default function HomePage() {
  return (
    <>
      <DashboardPage />
    </>
  );
}
